module.exports = __webpack_public_path__ + "img/check.13a899bb.svg";